import React from "react";
import { NonExecutionDay } from "../NonExecutionDays";
import { $Col, $Collapse, $Row, SelectedDays } from "us.common/components";
import { useTranslation } from "react-i18next";

/**
 * @description Non Printing Days Component
 * @link Design document - https://unicorn-solutions.atlassian.net/wiki/spaces/USU/pages/3049914453/Non+Email+Days+UI+Design
 * @author Rajitha Sanjayamal <rajithasa@unicorn-solutions.com>
 * @since 21/07/2022
 */
const NonPrintingDays: React.FC = () => {
  const { t } = useTranslation();

  return (
    <$Collapse
      className="non-sms-days"
      ghost
      defaultActiveKey={["1", "2"]}
      collapsible="header"
    >
      <$Collapse.Panel
        header={t("US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_PRINTING_DAYS")}
        key="1"
      >
        <$Row gutter={16}>
          <$Col xl={{ span: 12 }} xxl={{ span: 14 }} className="px-3">
            <NonExecutionDay />
          </$Col>
        </$Row>
      </$Collapse.Panel>
    </$Collapse>
  );
};

export default NonPrintingDays;
